module.exports = __webpack_public_path__ + "static/lights20-cc77f3145f9a17a3046a32a281b7aaf8.jpg";